/* eslint-disable max-len */
import * as React from "react";

export const SizeIcon = (props: Record<string, any>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        aria-hidden={true}
        role="img"
        {...props}
    >
        <path fill="none" stroke="#505050" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M0.998047 17C1.0112 15.8575 1.24905 14.7287 1.69805 13.678C2.18805 12.697 4.23705 12.017 6.80905 11.065C7.50905 10.807 7.39005 8.991 7.08205 8.652C6.59138 8.12067 6.21868 7.49154 5.98842 6.80595C5.75816 6.12035 5.67556 5.39379 5.74605 4.674C5.70198 4.21588 5.75268 3.75359 5.89497 3.3159C6.03726 2.87822 6.26812 2.4745 6.57316 2.12987C6.8782 1.78525 7.2509 1.50709 7.66808 1.31271C8.08525 1.11833 8.53796 1.01188 8.99805 1C9.45847 1.01134 9.91163 1.11739 10.3293 1.31153C10.7469 1.50568 11.1201 1.78376 11.4256 2.12844C11.731 2.47313 11.9622 2.87703 12.1048 3.31498C12.2473 3.75294 12.2981 4.21555 12.254 4.674C12.3245 5.39379 12.2419 6.12035 12.0117 6.80595C11.7814 7.49154 11.4087 8.12067 10.918 8.652C10.61 8.991 10.496 10.807 11.191 11.065C13.763 12.017 15.812 12.697 16.302 13.678C16.751 14.7287 16.9889 15.8575 17.002 17H0.998047Z" />
    </svg>
);
SizeIcon.displayName = "SizeIcon";
